<template>
  <ol class="cc-day-of-week">
    <li v-for="weekday in weekdays" :key="weekday">{{ weekday }}</li>
  </ol>
</template>

<script>
const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export default {
    name: "CalendarWeekdays",

    computed: {
        weekdays() {
            if(this.$i18n.locale == "nl"){
                return ["Ma", "Di", "Wo", "Do", "Vri", "Za", "Zo", ]
            }
            
            return WEEKDAYS;
        }
    }
};
</script>
